import React, { FC } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import { FileStoreEntity } from "../../../../../graphql/graphQlApiHooks";
import Settings from "../../../../../store/settings";

interface Props {
  open: boolean;
  onClose: () => void;
  tenantDetails?: string | null;
  tenantDetailsFile?: Pick<FileStoreEntity, 'id' | 'name' | 'url' | 'description' | 'ext'> | null;
}

const TenantDetailsDialog: FC<Props> = ({ open, onClose, tenantDetails, tenantDetailsFile }) => {
  
  const handleDownloadFile = () => {
    if (tenantDetailsFile?.url) {
      const downloadUrl = `${Settings.server}${tenantDetailsFile.url}`;
      window.open(downloadUrl, '_blank');
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          minHeight: tenantDetails || tenantDetailsFile ? 'auto' : 200,
          maxHeight: '90vh'
        }
      }}
    >
      <DialogTitle>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h6">
            Реквизиты организации
          </Typography>
          <IconButton
            onClick={onClose}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      
      <DialogContent sx={{ pb: 4 }}>
        <Stack spacing={2}>
          {tenantDetails && (
            <Box>
              <Typography 
                variant="subtitle2" 
                sx={{ mb: 1, fontWeight: 'bold' }}
              >
                Реквизиты:
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={tenantDetailsFile ? 6 : 10}
                value={tenantDetails}
                variant="outlined"
                InputProps={{
                  readOnly: true,
                }}
                sx={{
                  '& .MuiInputBase-input': {
                    fontSize: '0.875rem',
                    lineHeight: 1.5,
                    fontFamily: 'monospace'
                  }
                }}
              />
            </Box>
          )}
          
          {tenantDetailsFile && (
            <Box>
              <Typography 
                variant="subtitle2" 
                sx={{ mb: 1, fontWeight: 'bold' }}
              >
                Файл с реквизитами:
              </Typography>
              <Box
                sx={{
                  border: 1,
                  borderColor: 'divider',
                  borderRadius: 1,
                  p: 2,
                  bgcolor: 'background.default'
                }}
              >
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                      {tenantDetailsFile.name || 'Файл реквизитов'}
                    </Typography>
                    {tenantDetailsFile.description && (
                      <Typography variant="caption" color="text.secondary">
                        {tenantDetailsFile.description}
                      </Typography>
                    )}
                  </Box>
                  <Button
                    variant="contained"
                    size="small"
                    startIcon={<DownloadIcon />}
                    onClick={handleDownloadFile}
                  >
                    Скачать
                  </Button>
                </Stack>
              </Box>
            </Box>
          )}
          
          {!tenantDetails && !tenantDetailsFile && (
            <Box sx={{ textAlign: 'center', py: 2 }}>
              <Typography variant="body2" color="text.secondary">
                Реквизиты для данной заявки не указаны
              </Typography>
            </Box>
          )}
        </Stack>
      </DialogContent>
      
     
    </Dialog>
  );
};

export default TenantDetailsDialog;